import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const ControllingPercentage = ({ values }) => (
  <Content>
    {({
      signatoriesAndShareholdersPercentageLabel,
      signatoriesAndShareholdersPercentageValue1,
      signatoriesAndShareholdersPercentageValue2,
      signatoriesAndShareholdersPercentageValue3,
      globalRadioError
    }) => (
      <Field
        name="controlling_percentage"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="controlling_percentage"
            title={signatoriesAndShareholdersPercentageLabel}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.InlineSet
              groupName="controlling_percentage"
              items={[
                {
                  id: signatoriesAndShareholdersPercentageValue1,
                  labelText: signatoriesAndShareholdersPercentageValue1
                },
                {
                  id: signatoriesAndShareholdersPercentageValue2,
                  labelText: signatoriesAndShareholdersPercentageValue2
                },
                {
                  id: signatoriesAndShareholdersPercentageValue3,
                  labelText: signatoriesAndShareholdersPercentageValue3
                }
              ]}
              {...input}
              selectedId={values.controlling_percentage}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default ControllingPercentage;
